module.exports = __webpack_public_path__ + "static/MysteryA-36f5e9b7c12f703dd2d9dbc8d98a1a96.gif";